var map = {
	"./AIDesign.png": 6952,
	"./RB UX.png": 4393,
	"./RB.png": 1840,
	"./RBABOUT.png": 8405,
	"./RBResume.png": 6785,
	"./RPB.png": 6698,
	"./Ravindra.jpg": 817,
	"./Ravindra1.jpg": 9344,
	"./Screenshot 2024-10-09 at 7.27.01 PM.png": 8972,
	"./UX Design Process.png": 2586,
	"./UX Design Process1.png": 9,
	"./abel.jpeg": 4191,
	"./abhishek.jpeg": 3634,
	"./abmedia.png": 4353,
	"./aboutrb.png": 441,
	"./admin-dashboard.png": 2832,
	"./agile.png": 4990,
	"./akash.jpeg": 8483,
	"./alorb-technologies.png": 7497,
	"./apartment-management copy.png": 523,
	"./apartment-management.png": 6066,
	"./apartment.png": 8780,
	"./artgallery.png": 3907,
	"./aubergine-solutions.png": 2871,
	"./bookmyshow.png": 5114,
	"./brane-enterprises.png": 1063,
	"./cactus-communication.png": 6154,
	"./chesta.jpeg": 3869,
	"./connect.png": 7236,
	"./connectcase.png": 1832,
	"./cubyts.png": 2660,
	"./dell-technologies.png": 8994,
	"./digit-insurance.png": 9758,
	"./digital-grampanchayat.png": 7131,
	"./digitaledu.jpeg": 7829,
	"./divami-design-labs.png": 1520,
	"./dr.ravindra.png": 9971,
	"./dysgraphia.png": 6002,
	"./eq-technologic.png": 2844,
	"./extentia-information-technology.png": 7636,
	"./flytbase.png": 498,
	"./ginni.png": 9955,
	"./ginnicase.png": 5975,
	"./grey-orange.png": 4618,
	"./grocart-mockup.png": 636,
	"./grocart.png": 1838,
	"./joinit.png": 4411,
	"./joinitcase.png": 6959,
	"./khelnow-mockup.png": 3018,
	"./khelnow.png": 4868,
	"./laptop-illustration.png": 1549,
	"./lemon-yellow.png": 8950,
	"./logo.png": 3153,
	"./medcord.png": 9984,
	"./microsoft.png": 6410,
	"./mobile.png": 3370,
	"./nidhi.jpeg": 9995,
	"./nvidia-graphics.png": 8595,
	"./om.png": 7268,
	"./pos.png": 8244,
	"./qodequay.png": 2597,
	"./ravindra.png": 2217,
	"./research-insights.png": 9029,
	"./resident-app-mockup.png": 2704,
	"./resident-app.png": 2842,
	"./samsung.png": 1458,
	"./sap-ariba.png": 2232,
	"./sargam.png": 3739,
	"./sargamcase.png": 6975,
	"./sas-r&d.png": 6614,
	"./security-app.png": 8412,
	"./shashank.jpeg": 5594,
	"./shruti.jpeg": 356,
	"./siemens.png": 8592,
	"./solution-architecture.png": 949,
	"./sync-labs-ux-studio.png": 1165,
	"./sync4-mockup.png": 1061,
	"./system-design.png": 4428,
	"./tekion-corp.png": 7049,
	"./thought-craft.png": 8036,
	"./vr.png": 4988,
	"./yatra-case.png": 2806,
	"./yatra.png": 6567,
	"./yatracase.png": 1907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2889;